const data_tbu_pr = [
    { umur: 0, sd_3: 43.6, sd_2: 45.4, med: 49.1, sd2: 52.9, sd3: 54.7 },
    { umur: 1, sd_3: 47.8, sd_2: 49.8, med: 53.7, sd2: 57.6, sd3: 59.5 },
    { umur: 2, sd_3: 51.0, sd_2: 53.0, med: 57.1, sd2: 61.1, sd3: 63.2 },
    { umur: 3, sd_3: 53.5, sd_2: 55.6, med: 59.8, sd2: 64.0, sd3: 66.1 },
    { umur: 4, sd_3: 55.6, sd_2: 57.8, med: 62.1, sd2: 66.4, sd3: 68.6 },
    { umur: 5, sd_3: 57.4, sd_2: 59.6, med: 64.0, sd2: 68.5, sd3: 70.7 },
    { umur: 6, sd_3: 58.9, sd_2: 61.2, med: 65.7, sd2: 70.3, sd3: 72.5 },
    { umur: 7, sd_3: 60.3, sd_2: 62.7, med: 67.3, sd2: 71.9, sd3: 74.2 },
    { umur: 8, sd_3: 61.7, sd_2: 64.0, med: 68.7, sd2: 73.5, sd3: 75.8 },
    { umur: 9, sd_3: 62.9, sd_2: 65.3, med: 70.1, sd2: 75.0, sd3: 77.4 },
    { umur: 10, sd_3: 64.1, sd_2: 66.5, med: 71.5, sd2: 76.4, sd3: 78.9 },
    { umur: 11, sd_3: 65.2, sd_2: 67.7, med: 72.8, sd2: 77.8, sd3: 80.3 },
    { umur: 12, sd_3: 66.3, sd_2: 68.9, med: 74.0, sd2: 79.2, sd3: 81.7 },
    { umur: 13, sd_3: 67.3, sd_2: 70.0, med: 75.2, sd2: 80.5, sd3: 83.1 },
    { umur: 14, sd_3: 68.3, sd_2: 71.0, med: 76.4, sd2: 81.7, sd3: 84.4 },
    { umur: 15, sd_3: 69.3, sd_2: 72.0, med: 77.5, sd2: 83.0, sd3: 85.7 },
    { umur: 16, sd_3: 70.2, sd_2: 73.0, med: 78.6, sd2: 84.2, sd3: 87.0 },
    { umur: 17, sd_3: 71.1, sd_2: 74.0, med: 79.7, sd2: 85.4, sd3: 88.2 },
    { umur: 18, sd_3: 72.0, sd_2: 74.9, med: 80.7, sd2: 86.5, sd3: 89.4 },
    { umur: 19, sd_3: 72.8, sd_2: 75.8, med: 81.7, sd2: 87.6, sd3: 90.6 },
    { umur: 20, sd_3: 73.7, sd_2: 76.7, med: 82.7, sd2: 88.7, sd3: 91.7 },
    { umur: 21, sd_3: 74.5, sd_2: 77.5, med: 83.7, sd2: 89.8, sd3: 92.9 },
    { umur: 22, sd_3: 75.2, sd_2: 78.4, med: 84.6, sd2: 90.8, sd3: 94.0 },
    { umur: 23, sd_3: 76.0, sd_2: 79.2, med: 85.5, sd2: 91.9, sd3: 95.0 },
    { umur: 24, sd_3: 76.7, sd_2: 80.0, med: 86.4, sd2: 92.9, sd3: 96.1 },
    { umur: 24, sd_3: 76.0, sd_2: 79.3,med: 85.7,sd2: 92.2, sd3: 95.4 },
    { umur: 25, sd_3: 76.8, sd_2: 80.0,med: 86.6,sd2: 93.1, sd3: 96.4 },
    { umur: 26, sd_3: 77.5, sd_2: 80.8,med: 87.4,sd2: 94.1, sd3: 97.4 },
    { umur: 27, sd_3: 78.1, sd_2: 81.5,med: 88.3,sd2: 95.0, sd3: 98.4 },
    { umur: 28, sd_3: 78.8, sd_2: 82.2,med: 89.1,sd2: 96.0, sd3: 99.4 },
    { umur: 29, sd_3: 79.5, sd_2: 82.9,med: 89.9,sd2: 96.9, sd3: 100.3 },
    { umur: 30, sd_3: 80.1, sd_2: 83.6,med: 90.7,sd2: 97.7, sd3: 101.3 },
    { umur: 31, sd_3: 80.7, sd_2: 84.3,med: 91.4,sd2: 98.6, sd3: 102.2 },
    { umur: 32, sd_3: 81.3, sd_2: 84.9,med: 92.2,sd2: 99.4, sd3: 103.1 },
    { umur: 33, sd_3: 81.9, sd_2: 85.6,med: 92.9,sd2: 100.3, sd3: 103.9 },
    { umur: 34, sd_3: 82.5, sd_2: 86.2,med: 93.6,sd2: 101.1, sd3: 104.8 },
    { umur: 35, sd_3: 83.1, sd_2: 86.8,med: 94.4,sd2: 101.9, sd3: 105.6 },
    { umur: 36, sd_3: 83.6, sd_2: 87.4,med: 95.1,sd2: 102.7, sd3: 106.5 },
    { umur: 37, sd_3: 84.2, sd_2: 88.0,med: 95.7,sd2: 103.4, sd3: 107.3 },
    { umur: 38, sd_3: 84.7, sd_2: 88.6,med: 96.4, sd2: 104.2, sd3: 108.1 },
    { umur: 39, sd_3: 85.3, sd_2: 89.2,med: 97.1, sd2: 105.0, sd3: 108.9 },
    { umur: 40, sd_3: 85.8, sd_2: 89.8,med: 97.7, sd2: 105.7, sd3: 109.7 },
    { umur: 41, sd_3: 86.3, sd_2: 90.4,med: 98.4, sd2: 106.4, sd3: 110.5 },
    { umur: 42, sd_3: 86.8, sd_2: 90.9,med: 99.0, sd2: 107.2, sd3: 111.2 },
    { umur: 43, sd_3: 87.4, sd_2: 91.5,med: 99.7, sd2: 107.9, sd3: 112.0 },
    { umur: 44, sd_3: 87.9, sd_2: 92.0,med: 100.3, sd2: 108.6, sd3: 112.7 },
    { umur: 45, sd_3: 88.4, sd_2: 92.5,med: 100.9, sd2: 109.3, sd3: 113.5 },
    { umur: 46, sd_3: 88.9, sd_2: 93.1,med: 101.5, sd2: 110.0, sd3: 114.2 },
    { umur: 47, sd_3: 89.3, sd_2: 93.6,med: 102.1, sd2: 110.7, sd3: 114.9 },
    { umur: 48, sd_3: 89.8, sd_2: 94.1,med: 102.7, sd2: 111.3, sd3: 115.7 },
    { umur: 49, sd_3: 90.3, sd_2: 94.6,med: 103.3, sd2: 112.0, sd3: 116.4 },
    { umur: 50, sd_3: 90.7, sd_2: 95.1,med: 103.9, sd2: 112.7, sd3: 117.1 },
    { umur: 51, sd_3: 91.2, sd_2: 95.6, med: 104.5, sd2: 113.3, sd3: 117.7 },
    { umur: 52, sd_3: 91.7, sd_2: 96.1, med: 105.0, sd2: 114.0, sd3: 118.4 },
    { umur: 53, sd_3: 92.1, sd_2: 96.6, med: 105.6, sd2: 114.6, sd3: 119.1 },
    { umur: 54, sd_3: 92.6, sd_2: 97.1, med: 106.2, sd2: 115.2, sd3: 119.8 },
    { umur: 55, sd_3: 93.0, sd_2: 97.6, med: 106.7, sd2: 115.9, sd3: 120.4 },
    { umur: 56, sd_3: 93.4, sd_2: 98.1, med: 107.3, sd2: 116.5, sd3: 121.1 },
    { umur: 57, sd_3: 93.9, sd_2: 98.5, med: 107.8, sd2: 117.1, sd3: 121.8 },
    { umur: 58, sd_3: 94.3, sd_2: 99.0, med: 108.4, sd2: 117.7, sd3: 122.4 },
    { umur: 59, sd_3: 94.7, sd_2: 99.5, med: 108.9, sd2: 118.3, sd3: 123.1 },
    { umur: 60, sd_3: 95.2, sd_2: 99.9, med: 109.4, sd2: 118.9, sd3: 123.7 }, 
  ];

  export default data_tbu_pr;